export default __webpack_public_path__ + "images/warning.v-c0db9b4c305fa73bb1900871a61ca2fa.png";